import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { NeighborhoodViewControllerDelegate, NeighborhoodViewController } from "../../Screen/Neighborhood/NeighborhoodViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { NeighborhoodViewModel } from '../../Screen/Neighborhood/NeighborhoodViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class NeighborhoodCoordinator implements IndexCoordinatorDelegate, NeighborhoodViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("gepbairros")
        return (<ProtectedRoute requiredPermissions={['info_bas.bairros.*']} path="/:base/bairros" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'info_bas.bairros.adicionar',
                    edit: 'info_bas.bairros.editar',
                    delete: 'info_bas.bairros.excluir',
                }} 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Bairros"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new NeighborhoodViewModel()
        return (<ProtectedRoute requiredPermissions={['info_bas.bairros.adicionar', 'info_bas.bairros.editar']} path="/:base/bairros/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<NeighborhoodViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "gepbairros") {
            navigation.history.push(`bairros/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "gepbairros") {
            navigation.history.push(`bairros/cad/${idSelection}`);
            return;
        }
    }

}